<template>
  <div>
    <nav-bar/>
    <div class="container " id="ticketDetail" v-if="isContentLoaded">
      <div class="row page-padding">
        <div class="col-12">
          <v-card>
            <v-card-title class="py-2 cards-title">
              <div class="font16px white--text">اطلاعات تیکت</div>
            </v-card-title>
            <v-card-text>
              <div class="row">
                <div class="col-md-3">
                  <span>شناسه تیکت : </span> <span>{{ ticketsInfo.TicketNumber }}</span>
                </div>
                <div class="col-md-3">
                  <span>موضوع : </span> <span>{{ ticketsInfo.Subject }}</span>
                </div>
                <div class="col-md-3">
                  <span>دسته بندی : </span> <span>{{ ticketsInfo.category }}</span>
                </div>
                <div class="col-md-3 align-self-center">
                  <span>وضعیت : </span> <span>{{ $TypeTicketStatus[ticketsInfo.TypeTicketStatus - 1].name }}</span>
                </div>
                <div v-if="showChangeStatus" class="col-md-3">
                  <v-btn color="primary" class="rounded-lg" dark elevation="0"
                         @click="showChangeStatusDialog = true">
                    <span class="font16px">تغییر وضعیت </span>
                  </v-btn>
                </div>
                <div v-if="showReferTicket" class="col-md-3">
                  <v-btn color="primary" class="rounded-lg" dark elevation="0"
                         @click="showReferTicketDialog = true">
                    <span class="font16px">ارجاع تیکت </span>
                  </v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="col-12">
          <v-expansion-panels>
            <v-expansion-panel
            >
              <v-expansion-panel-header>
                پاسخ
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="row">
                  <div class="col-11 mx-auto">
                    <editor-content :editor="description" class="text-editor"/>
                  </div>
                  <div class="col">
                    <v-file-input id="fileInput1" class="input-border"
                                  v-model="fileUpload1"
                                  name="fileInput1" placeholder="فایل1" show-size solo flat dense hide-details
                                  append-icon="fa-paperclip"
                                  prepend-icon=""></v-file-input>
                  </div>
                  <div class="col">
                    <v-file-input v-model="fileUpload2" id="fileInput2" class="input-border"
                                  name="fileInput2" placeholder="فایل2" solo flat dense hide-details
                                  append-icon="fa-paperclip"
                                  prepend-icon=""></v-file-input>
                  </div>
                  <div class="col">
                    <v-file-input v-model="fileUpload3"
                                  id="fileInput3" class="input-border"
                                  name="fileInput3" placeholder="فایل3" solo flat dense hide-details
                                  append-icon="fa-paperclip"
                                  prepend-icon=""></v-file-input>
                  </div>
                  <div class="col">
                    <v-file-input v-model="fileUpload4" id="fileInput4" class="input-border"
                                  name="fileInput4" placeholder="فایل4" solo flat dense hide-details
                                  append-icon="fa-paperclip"
                                  prepend-icon=""></v-file-input>
                  </div>
                  <div class="col">
                    <v-file-input v-model="fileUpload5" id="fileInput5" class="input-border"
                                  name="fileInput5" placeholder="فایل5" solo flat dense hide-details
                                  append-icon="fa-paperclip"
                                  prepend-icon=""></v-file-input>
                  </div>
                  <div class="col-12 text-center">
                    <v-btn color="primary" class="rounded-lg" large dark
                           @click="replyTicket">
                      <span class="font16px">انجام</span>
                    </v-btn>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div v-for="item in ticketComments" :key="item.TicketCommentId" class="col-12">
          <v-card>
            <v-card-title class="py-2 " :class="[item.TypeRole === 'Client'? 'cards-title-light' : '' , 'cards-title']">
              <div class="row font16px white--text justify-content-between">
                <div class="col-auto py-0">
                  <span>{{ item.AppUserName }}</span> | <span>{{ $persianText(item.TypeRole) }}</span>
                </div>
                <div class="col-auto py-0">
                  <span>{{ $convertDate(item.CreatedDate) }}</span>
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="row">
                <div class="col-12 mt-2 border" v-html="item.Description"></div>

                <div v-if="item.FileUrl1 !== null" class="col-auto">
                  <span>
                  <a :href="item.FileUrl1" target="_blank">
                  <v-btn elevation="0" color="primary">
                    فایل1
                  </v-btn>
                  </a>
                </span>
                </div>
                <div v-if="item.FileUrl2 !== null" class="col-auto">
                  <span>
                  <a :href="item.FileUrl2" target="_blank">   <v-btn elevation="0" color="primary">
                    فایل2
                  </v-btn></a>
                </span>
                </div>
                <div v-if="item.FileUrl3 !== null" class="col-auto">
                  <span>
                  <a :href="item.FileUrl3" target="_blank"> <v-btn elevation="0" color="primary">
                    فایل3
                  </v-btn></a>
                </span>
                </div>
                <div v-if="item.FileUrl4 !== null" class="col-auto">
             <span>
                  <a :href="item.FileUrl4" target="_blank"> <v-btn elevation="0" color="primary">
                    فایل4
                  </v-btn></a>
                </span>
                </div>
                <div v-if="item.FileUrl5 !== null" class="col-auto">
                <span>
                  <a :href="item.FileUrl5" target="_blank"> <v-btn elevation="0" color="primary">
                    فایل5
                  </v-btn></a>
                </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showChangeStatusDialog"
        persistent
        width="500">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <div>تغییر وضعیت تیکت</div>
          <v-btn
              color="primary"
              icon
              small
              @click="showChangeStatusDialog = false"
          >
            <i class="fas fa-times font-16"></i>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="black--text p-3">
            <v-autocomplete
                solo
                flat
                dense
                hide-details
                color="primary"
                class="input-border"
                :items="$TypeTicketStatus"
                v-model="TypeTicketStatus"
                item-text="name"
                item-value="id"
                placeholder="وضعیت تیکت را انتخاب کنید">
            </v-autocomplete>
          </div>
          <div class="col-12 text-center">
            <v-btn color="primary" class="rounded-lg" dark elevation="0"
                   @click="changeTicketStatus">
              <span class="font16px">انجام</span>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showReferTicketDialog"
        persistent
        width="500">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <div class="white--text">ارجاع تیکت</div>
          <v-btn
              color="primary"
              icon
              small
              @click="showReferTicketDialog = false"
          >
<!--            <i class="fas fa-times font-16"></i>-->
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="black--text p-3">
            <v-autocomplete
                solo
                flat
                dense
                hide-details
                color="primary"
                class="input-border"
                :items="personnels"
                v-model="personnelModel"
                item-text="fullName"
                item-value="ID"
                placeholder="پرسنل را انتخاب کنید.">
            </v-autocomplete>
          </div>
          <div class="col-12 text-center">
            <v-btn color="primary" class="rounded-lg" dark elevation="0"
                   @click="referTicket">
              <span class="font16px">انجام</span>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";
import {Editor, EditorContent} from "tiptap";

export default {
  name: "ticketsDetailClient",
  components: {NavBar, EditorContent},
  data: () => ({
    isContentLoaded: false,
    showChangeStatus: false,
    ticketsInfo: {},
    showLoaderDialog: false,
    showReferTicket: false,
    showResultDialog: false,
    showChangeStatusDialog: false,
    showReferTicketDialog: false,
    dialogResult: null,
    TypeTicketStatus: null,
    categoryList: [],
    UserItems: [],
    personnels: [],
    ticketComments: [],
    fileUpload1: null,
    fileUpload2: null,
    fileUpload3: null,
    fileUpload4: null,
    fileUpload5: null,
    description: null,
    personnelModel: null,
  }),
  mounted() {
    this.getCategory()
    this.description = new Editor({
      content: '',
    })
    if (this.$getUserData().role !== 5) {
      this.showChangeStatus = true
    }
  },
  methods: {
    getAllUsers() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ListAllUsers", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            this.UserItems = json
            for (let i = 0; i < json.length; i++) {
              json[i].fullName = json[i].Name + " " + json[i].Family;
            }
            this.showLoaderDialog = false
            this.getPersonnel()
          })
          .catch(error => console.log('error', error));
    },
    getPersonnel() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ListPersonnel?IsActive=true", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)
            this.showReferTicket = true
            this.personnels = json
            for (let i = 0; i < json.length; i++) {
              json[i].fullName = json[i].Name + " " + json[i].Family;
            }
            this.getTicketDetails()
          })
          .catch(error => console.log('error', error));
    },
    clearForm() {
      this.description.destroy()
      this.description = new Editor({
        content: '',
      });
      this.fileUpload1 = null;
      this.fileUpload2 = null;
      this.fileUpload3 = null;
      this.fileUpload4 = null;
      this.fileUpload5 = null;
    },
    getCategory() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetActiveTicketCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.categoryList = JSON.parse(result)
            this.getAllUsers()
          })
          .catch(error => console.log('error', error));
    },
    getTicketDetails() {
      if (this.$getUserData().role === 5) {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/UserTicketDetail?ticketId=" + this.$route.query.id, requestOptions)
            .then(response => response.text())
            .then(result => {
              let json = JSON.parse(result)

              this.ticketsInfo = json.ticket

              let user = this.UserItems.filter(x => x.Id === json.ticket.StartedUserId)[0]
              this.ticketsInfo.user = user.Name + " " + user.Family

              for (let i = 0; i < json.ticketComments.length; i++) {
                let tempUser = this.UserItems.filter(x => x.Id === json.ticketComments[i].AppUserId)[0];
                json.ticketComments[i].AppUserName = tempUser.Name + " " + tempUser.Family;
              }

              let category = this.categoryList.filter(x => x.TicketCategoryId === json.ticket.TicketCategoryId)[0]
              this.ticketsInfo.category = category.Name
              this.ticketComments = json.ticketComments
              this.ticketComments.push({
                Description: this.ticketsInfo.Description,
                CreatedDate: this.ticketsInfo.CreatedDate,
                TypeRole: this.ticketsInfo.TypeRole, FileUrl1: this.ticketsInfo.FileUrl1,
                FileUrl2: this.ticketsInfo.FileUrl2,
                FileUrl3: this.ticketsInfo.FileUrl3,
                FileUrl4: this.ticketsInfo.FileUrl4,
                FileUrl5: this.ticketsInfo.FileUrl5,
                AppUserName: this.ticketsInfo.user,
              })
              this.isContentLoaded = true

            })
            .catch(error => console.log('error', error));
      } else {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/TicketDetail?ticketId=" + this.$route.query.id, requestOptions)
            .then(response => response.text())
            .then(result => {
              let json = JSON.parse(result)

              this.ticketsInfo = json.ticket

              let user = this.UserItems.filter(x => x.Id === json.ticket.StartedUserId)[0]
              this.ticketsInfo.user = user.Name + " " + user.Family

              for (let i = 0; i < json.ticketComments.length; i++) {
                let tempUser = this.UserItems.filter(x => x.Id === json.ticketComments[i].AppUserId)[0];
                json.ticketComments[i].AppUserName = tempUser.Name + " " + tempUser.Family;
              }

              let category = this.categoryList.filter(x => x.TicketCategoryId === json.ticket.TicketCategoryId)[0]
              this.ticketsInfo.category = category.Name
              this.ticketComments = json.ticketComments
              this.ticketComments.push({
                Description: this.ticketsInfo.Description,
                CreatedDate: this.ticketsInfo.CreatedDate,
                TypeRole: this.ticketsInfo.TypeRole, FileUrl1: this.ticketsInfo.FileUrl1,
                FileUrl2: this.ticketsInfo.FileUrl2,
                FileUrl3: this.ticketsInfo.FileUrl3,
                FileUrl4: this.ticketsInfo.FileUrl4,
                FileUrl5: this.ticketsInfo.FileUrl5,
                AppUserName: this.ticketsInfo.user,
              })
              this.isContentLoaded = true

            })
            .catch(error => console.log('error', error));
      }

    },
    changeTicketStatus() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("ticketId", this.$route.query.id);
      formdata.append("ticketStatus", this.TypeTicketStatus);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ChangeTicketStatus", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showChangeStatusDialog = false
            this.getTicketDetails()
          })
          .catch(error => console.log('error', error));
    },
    replyTicket() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("TicketId", this.$route.query.id);
      formdata.append("Description", this.description.getHTML());
      if (document.getElementById('fileInput1').files[0] !== undefined) {
        formdata.append("File1", document.getElementById('fileInput1').files[0]);
      }
      if (document.getElementById('fileInput2').files[0] !== undefined) {
        formdata.append("File2", document.getElementById('fileInput2').files[0]);
      }
      if (document.getElementById('fileInput3').files[0] !== undefined) {
        formdata.append("File3", document.getElementById('fileInput3').files[0]);
      }
      if (document.getElementById('fileInput4').files[0] !== undefined) {
        formdata.append("File4", document.getElementById('fileInput4').files[0]);
      }
      if (document.getElementById('fileInput5').files[0] !== undefined) {
        formdata.append("File5", document.getElementById('fileInput5').files[0]);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      let url = "/Client/ReplyTicketByUser";
      if (this.$getUserData().role !== 5) {
        url = "/Client/ReplyTicket"
      }

      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showResultDialog = true
            this.dialogResult = result
            this.showLoaderDialog = false

            this.clearForm()
            this.getTicketDetails()

          })
    },
    referTicket() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("ticketId", this.$route.query.id);
      formdata.append("appUserId", this.personnelModel);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ReferTicket", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showResultDialog = true
            this.$router.push({path:'listTickets'})

          })
          .catch(error => console.log('error', error));
    }

  }
}
</script>

<style scoped>

</style>